import { DEACTIVATED, WORKFLOWS_ASSIGNMENT_ACCESS } from 'automation-ui-action-features/constants/Scopes';
import http from 'hub-http/clients/apiClient';
import memoize from 'transmute/memoize';
import * as t from 'ts-schema';
const userIdsSchema = t.array(t.number);
export const fetchAssignableUserIds = memoize(() => http.get(`users/v2/app/scopes/${WORKFLOWS_ASSIGNMENT_ACCESS}/user-ids`).then(response => t.assert(userIdsSchema, response)));
export const fetchDeactivatedUserIds = memoize(() => http.get(`users/v2/app/scopes/${DEACTIVATED}/user-ids`).then(response => t.assert(userIdsSchema, response)));